// src/routes/ProtectedRoute.js
import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { useNavigation } from "./utils/navigation";
import { AuthUserContext } from "./context/AuthUserContext";
import { jwtDecode } from "jwt-decode";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ children }) => {
  const { goToLogin } = useNavigation();
  const { authTokens } = useContext(AuthUserContext);

  if (!authTokens) {
    return <Navigate to={goToLogin()} replace />;
  }
  return children;
};

const ProtectedRouteCheckout = ({ children }) => {
  const { goToRegister, goToVerification, goToShop } = useNavigation();
  const { authTokens } = useContext(AuthUserContext);

  const cartItems = useSelector((state) => state.cart.itemsList);
  let totalQuantity = cartItems.reduce(
    (total, item) => total + item.quantity,
    0
  );
  if (totalQuantity == 0) {
    return <Navigate to={goToShop()} replace />;
  }
  if (!authTokens) {
    return <Navigate to={goToRegister()} replace />;
  } else {
    // const decoded = jwtDecode(authTokens.access);
    // console.log("email", decoded.email, decoded.is_email_verified);
    // if (!decoded.is_email_verified) {
    //   return <Navigate to={goToVerification()} replace />;
    // }
  }
  return children;
};

const ProtectedRouteSignUpIn = ({ children }) => {
  const { goToAccount } = useNavigation();
  const { authTokens } = useContext(AuthUserContext);

  if (authTokens) {
    return <Navigate to={goToAccount()} replace />;
  }
  return children;
};

export default ProtectedRoute; // Podrazumevani eksport
export { ProtectedRouteCheckout, ProtectedRouteSignUpIn }; // Imenovani eksport
